{
    "form_title": "Neue Lieferadresse",
    "form_sub_title": "Diese wird in der Warenwirtschaft gespeichert und ist für alle sichtbar",

    "form_label__address_line_1": "Adresszeile",
    "form_label__address_line_2": "Adresszeile 2",
    "form_label__street": "Straße und Hausnummer",
    "form_label__zip_code": "Postleitzahl",
    "form_label__city": "Stadt",
    "form_label__country_code": "Land",

    "form_placeholder__address_line_1": "Muster GmbH",
    "form_placeholder__address_line_2": "c/o Muster Industrie GmbH",
    "form_placeholder__street": "Musterweg 42",
    "form_placeholder__zip_code": "124123",
    "form_placeholder__city": "Musterstadt",
    "form_placeholder__country_code": "Deutschland"
}
